import { render, staticRenderFns } from "./Krepselis.vue?vue&type=template&id=09059a71&"
import script from "./Krepselis.vue?vue&type=script&lang=js&"
export * from "./Krepselis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports